import React, { Fragment } from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

const defaultRenderer = contents => typeof contents === 'string' ? contents : React.createElement(Fragment, null, contents.map((v, k) => React.createElement(Fragment, {
  key: k
}, v)));

const stringRenderer = contents => typeof contents === 'string' ? contents : contents.map(String).join('');

const CONFIG = {
  tracker: s => window.console.error(s),
  intlData: {},
  renderer: defaultRenderer
};
const addIntlData = data => {
  CONFIG.intlData = _objectSpread2({}, CONFIG.intlData, {}, data);
};
const configure = config => Object.keys(config).forEach(key => {
  CONFIG[key] = config[key];
});

const destructure = (raw, msg) => {
  const {
    id,
    values
  } = msg;
  const matches = raw.match(/{[a-z]+}/gi);

  if (!matches) {
    if (values) CONFIG.tracker('Ignoring specified values for: ' + id);
    return raw;
  }

  let toProcess = raw;
  const result = [];
  const used = [];
  const phValues = values || {};
  matches.forEach(ph => {
    const phIndex = toProcess.indexOf(ph);
    const key = ph.slice(1, -1);
    const value = phValues[key];
    used.indexOf(key) === -1 && used.push(key);
    result.push(toProcess.substr(0, phIndex));

    if (value !== undefined) {
      result.push(value);
    } else {
      result.push(ph);
      CONFIG.tracker(`Missing placeholder "${key}" for: ${id}`);
    }

    toProcess = toProcess.substr(phIndex + ph.length);
  });
  toProcess && result.push(toProcess);

  if (used.length < Object.keys(phValues).length) {
    CONFIG.tracker('Redundant placeholders for: ' + id);
  }

  if (result.every(v => typeof v === 'number' || typeof v === 'string')) {
    return result.join('');
  }

  return result;
};

const render = (msg, renderer) => {
  const m = typeof msg === 'string' ? {
    id: msg
  } : msg;
  const raw = CONFIG.intlData[m.id];

  if (!raw) {
    CONFIG.tracker('No translation for key: ' + m.id);
    return renderer(m.id);
  }

  return renderer(destructure(raw, m));
};

const __internal = {
  render
};
const __ = (msg, renderer = CONFIG.renderer) => __internal.render(msg, renderer);
const __string = (msg, renderer = stringRenderer) => __internal.render(msg, renderer);

export { __, __internal, __string, addIntlData, configure };
